import React, {useEffect, useState, useRef} from "react";
import {useSelector, useDispatch} from "react-redux";
import propTypes from "prop-types";
import {MultipleAnimation} from "Animations";
import {searchActions} from "../../framework/redux/actions/index";
import {SearchHit} from "./hits/SearchHit";
import {
    HitsWrapper,
    SearchWrapper,
    SearchTopWrapper,
    SearchInputWrapper,
    SearchTop,
    NoHitsTextParagraph,
    HitsCountWrapper,
    HitsCategoriesWrapper,
} from "./hits/StyledSearch";
import {H1, Paragraph} from "BaseComponents/Text";
import {Input} from "BaseComponents/Form";
import {SubmitButton, ButtonText, PrimaryButton} from "Buttons";
import {SearchHitWithCategory} from "./hits/SearchHitWithCategory";
import {SearchCategory} from "./hits/SearchCategory";

export const Search = ({
                           Heading,
                           SearchHits,
                           TotalHits,
                           SearchText,
                           ShowMoreText,
                           ShowPriorityItem,
                           SearchQuery: {
                               CurrentCulture,
                               CurrentPageId,
                               DocumentTypes,
                               IsFallbackText,
                               FallbackSearchText,
                               NoHitsText,
                               Query,
                               Skip,
                               StartPageId,
                               Take,
                               SearchHitsText,
                               TakeNrFromPage,
                               OrderResultsBy,
                               Categories,
                               NotInId,
                               PriorityId,
                           },
                           AllCategories,
                           AllCategoriesText,
                           hideField = false,
                           withCategories = false,
                           isNewDesign = false,
                       }) => {
    const state = useSelector((state) => state.search);
    const [loading, setLoading] = useState(useSelector((state) => state.loading));
    const [take, setTake] = useState(Take);
    const [skip, setSkip] = useState(Skip);
    const [initialTake, setInitialTake] = useState(Take);
    const [searchHitsText, setSearchHitsText] = useState(
        useSelector((state) => state.searchHitsText)
    );
    const [initialSearch, setInitialSearch] = useState(true);

    const [searchQuery, setSearchQuery] = useState(
        useSelector((state) => state.query)
    );
    const [searchHits, setSearchHits] = useState(
        useSelector((state) => state.items)
    );
    const [hitCount, setHitCount] = useState(
        useSelector((state) => state.TotalCount)
    );
    const [filterCategory, setFilterCategory] = useState(
        useSelector((state) => state.categories ?? [])
    );

    const dispatch = useDispatch();
    const inputEl = useRef(null);
    useEffect(() => {
        //TODO: filtrera
        setSearchHits(state.items);
        setHitCount(state.TotalCount);
        setLoading(state.loading);
        setSearchHitsText(state.searchHitsText);
    });

    useEffect(() => {
        if (!hideField) {
            inputEl.current.value = Query;
            if (Query !== undefined) {
                setSearchQuery(Query);
            }
        }
        Get(true);
    }, []);

    useEffect(() => {
        if (initialSearch) {
            setInitialSearch(false);
        } else {
            Get();
        }
    }, [searchQuery]);

    useEffect(() => {
        if (initialSearch) {
            setInitialSearch(false);
        } else {
            Get();
        }
    }, [filterCategory]);

    useEffect(() => {
        if (initialSearch) {
            setInitialSearch(false);
        } else {
            GetMore();
        }
    }, [take]);
    const Get = (initial) => {
        if (
            (searchQuery !== undefined && searchQuery.length > 0) ||
            initialSearch ||
            filterCategory
        ) {
            setLoading(true);
            dispatch(
                searchActions.get(
                    initial ? SearchHits : searchHits,
                    initial ? Query : searchQuery !== undefined ? searchQuery : Query,
                    initial || searchQuery !== undefined ? Take : take,
                    initial || searchQuery !== undefined ? Skip : skip,
                    initial ? SearchHitsText : searchHitsText,
                    CurrentCulture,
                    DocumentTypes,
                    StartPageId,
                    CurrentPageId,
                    TakeNrFromPage,
                    initialSearch,
                    TotalHits,
                    OrderResultsBy,
                    filterCategory,
                    NotInId,
                    PriorityId
                )
            );
        }
    };

    const GetMore = () => {
        setLoading(true);
        dispatch(
            searchActions.get(
                searchHits,
                // searchQuery !== undefined ? searchQuery : Query,
                searchQuery,
                take,
                skip,
                // searchQuery !== undefined ? searchHits.length + initialTake : take,
                // searchQuery !== undefined ? searchHits.length : skip,
                searchHitsText,
                CurrentCulture,
                DocumentTypes,
                StartPageId,
                CurrentPageId,
                TakeNrFromPage,
                initialSearch,
                TotalHits,
                OrderResultsBy,
                filterCategory,
                NotInId,
                PriorityId
            )
        );
    };

    const HandleClick = () => {
        if (inputEl.current.value !== searchQuery) {
            setSearchQuery(inputEl.current.value);
        }
    };

    const HandleEnterClick = (e) => {
        if (e.key === "Enter") {
            HandleClick();
        }
    };
    return (
        <SearchWrapper>
            {!isNewDesign ? (
                <>
                    <SearchTopWrapper>
                        <SearchTop>
                            {!!Heading.length && <H1>{Heading}</H1>}
                            <SearchInputWrapper>
                                <Input
                                    ref={inputEl}
                                    placeholder={SearchText}
                                    onKeyDown={(e) => HandleEnterClick(e)}
                                    disabled={IsFallbackText}
                                />
                                <SubmitButton
                                    className={"searchButton"}
                                    width="auto"
                                    padding="0 15px"
                                    widthsmall="auto"
                                    heightsmall="58px"
                                    onClick={(e) => HandleClick()}
                                    height="58px"
                                    disabled={IsFallbackText}
                                    noBorderLeftOnHover
                                >
                                    <ButtonText
                                        forcedFontSize="24px"
                                        forcedFontSizeSmall="18px"
                                        heading={Heading || "search button"}
                                    >
                                        {SearchText}
                                    </ButtonText>
                                </SubmitButton>
                            </SearchInputWrapper>
                            <Paragraph
                                large
                                dangerouslySetInnerHTML={{__html: searchHitsText}}
                            ></Paragraph>
                            {IsFallbackText && (
                                <Paragraph
                                    large
                                    bold
                                    display="block"
                                    margin="1rem 0 0 0"
                                    dangerouslySetInnerHTML={{__html: FallbackSearchText}}
                                ></Paragraph>
                            )}
                        </SearchTop>
                    </SearchTopWrapper>
                    <HitsWrapper>
                        {searchHits !== undefined && (
                            <MultipleAnimation
                                items={initialSearch ? SearchHits : searchHits}
                                loading={loading}
                                mass={15}
                                tension={2000}
                                friction={200}
                            >
                                <SearchHit/>
                            </MultipleAnimation>
                        )}
                        {!loading && hitCount == 0 && (
                            <NoHitsTextParagraph>{NoHitsText}</NoHitsTextParagraph>
                        )}
                    </HitsWrapper>
                </>
            ) : (
                <>
                    {withCategories && (
                        <HitsCountWrapper>
                            <HitsCategoriesWrapper>
                                <SearchCategory
                                    categories={AllCategories}
                                    allCategoriesText={AllCategoriesText}
                                    onCategoryChange={(value) => {
                                        setSkip(Skip);
                                        setFilterCategory(value ? [value] : []);
                                        setTake(Take);
                                    }}
                                />
                            </HitsCategoriesWrapper>
                            <Paragraph
                                margin={"10px 0"}
                                fontSize={"16px"}
                                large
                                dangerouslySetInnerHTML={{__html: searchHitsText}}
                            ></Paragraph>
                        </HitsCountWrapper>
                    )}
                    <HitsWrapper flex showPriority={ShowPriorityItem}>
                        {searchHits !== undefined && (
                            <MultipleAnimation
                                items={initialSearch ? SearchHits : searchHits}
                                loading={loading}
                                mass={15}
                                tension={2000}
                                friction={200}
                            >
                                <SearchHitWithCategory showPriority={ShowPriorityItem} flex/>
                            </MultipleAnimation>
                        )}
                        {!loading && hitCount == 0 && (
                            <NoHitsTextParagraph>{NoHitsText}</NoHitsTextParagraph>
                        )}
                    </HitsWrapper>
                </>
            )}
            {searchHits != undefined && hitCount > searchHits.length && (
                <PrimaryButton
                    justifycontent="center"
                    display="flex"
                    margin="0 auto 3rem auto"                   
                    onClick={() => {
                        setTake(take + initialTake);
                        setSkip(skip + initialTake);
                    }}
                    href={'#'}
                >
                    <ButtonText heading={'search button'}>{ShowMoreText}</ButtonText>
                </PrimaryButton>
            )}
        </SearchWrapper>
    );
};

Search.propTypes = {
    Heading: propTypes.string,
};
